import DOMPurify from "dompurify";

const richHtmlConfig = {
  ALLOWED_TAGS: ["br", "p", "strong", "b", "em", "i", "u", "ul", "ol", "li", "a"],
  ALLOWED_ATTR: ["href", "target", "rel"]
};

export function sanitizeRichHtml(value: string | null | undefined): string {
  const sanitized = DOMPurify.sanitize(value || "", richHtmlConfig) as string;

  if (!sanitized || typeof document === "undefined") {
    return sanitized;
  }

  const wrapper = document.createElement("div");
  wrapper.innerHTML = sanitized;
  wrapper.querySelectorAll('a[target="_blank"]').forEach(anchor => {
    anchor.setAttribute("rel", "noopener noreferrer");
  });

  return wrapper.innerHTML;
}

export function openUrlSafely(url: string, blank = true): void {
  if (!blank) {
    window.location.assign(url);
    return;
  }

  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) {
    newWindow.opener = null;
  }
}
